export default __webpack_public_path__ + "static/svg-4-dfbca26e8f125c6d4a613f24666120c2.svg";